import { AdminUserPermissionSet, OrganizationPermissionSet, PermissionSetType, PlatformPermissionSet } from '../sets'

/**
 * Virtual role of basic operators who can use the admin panel but cannot do
 * anything other than minimal operations.
 *
 * Please do not add any permissions that are specific to a product (e.g. view vehicles, daily request counts)
 */
export const AdminMinimalRole: PermissionSetType[] = [
  PlatformPermissionSet.UsePortal,

  OrganizationPermissionSet.ViewConfiguration,
  OrganizationPermissionSet.ViewBackupSettings,
  OrganizationPermissionSet.ViewCustomSchemas,

  AdminUserPermissionSet.EditOwn,
  AdminUserPermissionSet.View,
]
